import {
  PerformOfferActionMutationMutationCgResponse,
  PerformOfferActionMutationMutationVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

export const PERFORM_OFFER_ACTION_MUTATION: TypedDocumentNode<
  PerformOfferActionMutationMutationCgResponse,
  PerformOfferActionMutationMutationVariables
> = gql`
  mutation PerformOfferActionMutation(
    $offerId: ID!
    $input: PerformOfferActionInput!
  ) {
    performOfferAction(offerId: $offerId, input: $input) {
      offer {
        id
        state
        stateChangedAt
        startDate
        endDate
        billingRegularRate
        timeoffDescription
        shiftType
        shiftsPerWeek
        hoursPerShift
        createdAt

        staffingRequest {
          id
          openStaffingRequestPositionsCount
          state
        }

        staffingRequestAssignment {
          id
          state
          assignmentTerms {
            id
            currentlyActive
            upcoming
            effectiveAt
            startDate
            endDate
            lengthInWeeks
            billingRegularRate
            shiftsPerWeek
            hoursPerShift
            shiftType
            timeoffDescription
            createdByName
            updatedFields
            updatedAt
            createdAt
          }
        }

        canAccept {
          value
        }
        canReject {
          value
        }

        staffingRequestApplication {
          id
          state
          stateChangedAt
          staffingRequest {
            id
            submittedStaffingRequestApplicationsCount
            inReviewStaffingRequestApplicationsCount
            offeredOffersStaffingRequestApplicationsCount
            acceptedStaffingRequestApplicationsCount
            withdrawnStaffingRequestApplicationsCount
            rejectedStaffingRequestApplicationsCount
          }
        }
      }
      error
    }
  }
`;
